import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'highlight'
})
export class FilterHighlightPipe implements PipeTransform {

    constructor(private readonly sanitizer: DomSanitizer) {}

    transform(text: string = '', mask: string = '', minLengthText: string = '1'): SafeHtml {
        if (!text.length || !mask.trim().length || +minLengthText > mask.length) {
            return text;
        }

        let pattern = mask.trim().replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\,\\\^\$\|\#]/g, '\\$&');
        pattern = pattern
            .split(' ')
            .filter(t => t.length > 0)
            .join('|');
        const regex = new RegExp(pattern, 'gi');

        return this.sanitizer.bypassSecurityTrustHtml(
            text.replace(regex, match => `<span class='highlight'>${ match }</span>`)
        );
    }
}
